import React, { Component } from 'react'
import { Tooltip } from '@material-ui/core'
import { EditableInput } from '../../common/EditableComponents'

import { getLinkIcon, MASTER_CATEGORY, MASTER_PRODUCT } from '../CommonUpdateCells'

export const AmountComponent = (props) => {
  const { value, data, colDef } = props
  const activeShop = data && data.shop && data.shop.active
  const deletedShop = data && data.shop && data.shop.deleted
  const orphaned = colDef.obj === 'CATEGORY' ? !data.parentCategoryId : !data.masterId
  const masterType = colDef.obj === 'CATEGORY' ? MASTER_CATEGORY : MASTER_PRODUCT
  let isParent = !!data.children

  const shouldHide =
    ((!activeShop || deletedShop) && !data.children) ||
    (orphaned && !isParent) ||
    (data.productType && data.productType == 'BUNDLE')
  let linkIcon = getLinkIcon(masterType, isParent, data, colDef.field)
  const amountValue = parseFloat(value) || 0

  const hideCurrency = props.hideCurrency || false

  const handleIconOption = (event) => {
    if (props.onSyncChildEvent) {
      props.onSyncChildEvent(props, {
        icon: linkIcon.icon,
        title: linkIcon.title,
      })
    }
  }
  return (
    <div className="center-item-column">
      <div className="align-item-column-value">
        {!hideCurrency ? '$' : ''}
        {amountValue.toFixed(2)}
      </div>

      <div style={{ float: 'right' }}>
        <Tooltip title={linkIcon.title}>
          <img
            className="icon-validation"
            alt=""
            src={linkIcon.icon}
            hidden={shouldHide}
            onClick={(event) => handleIconOption(event)}
          />
        </Tooltip>
      </div>
    </div>
  )
}

export class AmountEditor extends Component {
  state = { value: this.props.value }

  handleChange = (event) => {
    const value = parseFloat(event.target.value) || 0
    this.setState({ value })
  }
  afterGuiAttached = () => {}
  getValue = () => this.state.value
  destroy = () => {}

  render() {
    const { value } = this.state

    const { precision } = this.props

    return (
      <div className="center-item-column">
        <div className="align-item-column-value">
          <EditableInput
            type="number"
            editMode={true}
            material={false}
            value={value}
            precision={precision}
            onChange={(event) => this.handleChange(event)}
            valueToRender={value}
          />
        </div>
      </div>
    )
  }
}

export default {
  AmountComponent,
  AmountEditor,
}



// WEBPACK FOOTER //
// ./src/components/MasterCatalog/Components/AmountComponent.js